import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationDto } from '@cradua/data';
import { RoleDto } from '@cradua/domain';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-application-container',
  templateUrl: './application-container.component.html',
  styleUrls: ['./application-container.component.scss']
})
export class ApplicationContainerComponent implements OnInit {
applications$: Observable<ApplicationDto[]>;
roles$: Observable<RoleDto[]>;

isLoading$: Observable<boolean>;
isLoadingRole$: Observable<boolean>;

  constructor(private gatewayFacade: GatewayFacade, private router: Router) { }

  ngOnInit(): void {
  this.isLoading$ = this.gatewayFacade.isLoadingGateway('Application');
  this.isLoadingRole$ = this.gatewayFacade.isLoadingGateway('Role');
  this.applications$ = this.gatewayFacade.loadGateway('Application');
  this.roles$ = this.gatewayFacade.loadGateway('Role');
  }

  onEmitAssignedRole(value) {
    console.log('staff role ', value)
    this.gatewayFacade.add("StaffRoleNew", value);
  }


  onSubmit(data) {
  const roles = data.Roles.filter(bc => bc.isChecked === true);
  const updatedData = [];
  const savedData = [];
  for(let role of roles) {
    if(role.id) {
      updatedData.push(role);
    } else {
      delete role.id;
      savedData.push(role);
    }
  }

  if(savedData.length > 0) {
    this.gatewayFacade.add('Application', savedData);
  }

  if(updatedData.length > 0) {
    this.gatewayFacade.update('Application', updatedData, ['id']);
  }

  }

  onDeleteapplication(ids) {
    this.gatewayFacade.remove('Application', ids);
  }
}
